import { makeSx } from '../../../../../theme/_utils'

export default makeSx({
    button: {
        textDecoration: 'none',
        fontWeight: 600,
        textAlign: 'right',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '1em',
        color: '#343434',
        gap: '.5rem',
    },
})
